import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Loader2, AlertTriangle } from 'lucide-react';
import { useImpersonationExchange } from '@clareefai/api/impersonation-hooks';
import { useAuth } from '../contexts/AuthContext';

const ImpersonateExchange: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { loginWithCustomToken } = useAuth();
  const code = searchParams.get('code');

  const { errorMessage } = useImpersonationExchange({
    code,
    loginWithCustomToken,
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api',
    redirectPath: '/dashboard',
  });

  if (!code) {
    return <Navigate to="/login" replace />;
  }

  if (errorMessage) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="max-w-md w-full bg-white border border-red-200 rounded-xl shadow-sm p-8 text-center">
          <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-gray-900 mb-2">Impersonation failed</h1>
          <p className="text-sm text-gray-600 mb-6">{errorMessage}</p>
          <button
            onClick={() => window.close()}
            className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-900 text-sm"
          >
            Close tab
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-amber-500 mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-900">Starting impersonation session…</h2>
      </div>
    </div>
  );
};

export default ImpersonateExchange;
